// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"Chart-chartWrapper-1-hChqE7Uy","chart":"Chart-chart-ylRvJhrpEP","legend":"Chart-legend-bgL6tOsxt8"};